module.exports = __webpack_public_path__ + "static/index/img/baikal-502.61f362c8.jpg";